import { ClosureReason } from "./activity_vacancies.types";

export const requiresProfileId = (reason: ClosureReason): boolean =>
  reason.key === "filled_with_named_resource";
